import { FC, memo, ReactElement, useEffect, useCallback, useMemo, useRef, useState } from 'react';
import { Colors, FlexBox, Skeleton, useBreakpoint as useBreakpointClient } from '@brg/ui';
import styled, { useTheme, css } from 'styled-components';
import { API, Project, Tag, TagsAPI } from '@brg/api';
import { AppTester } from '../../../supporting';
import { ProjectImageWrapper, ProjectLongreadWrapper } from '../../pages/project/styles';
import { ProjectContainerLayout } from './project-container-layout';
import ProjectHeader from '../../pages/project/components/ProjectHeader';
import TagsMobile from "../../pages/project/components/TagsMobile";
import { BTag } from "../../../core/components";
import { LayoutConst } from "../../../core";
import { useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {LinkTo} from 'shared/constants/linkTo';
import { MainBookTitle } from '_deziiign/books/pages/BookView/components/MainBookTitle';
import { TagsMobBtn } from '../TagsMobBtn/TagsMobBtn';
import { useSelector } from "react-redux";
import { VOTE_BLOCK_POSITION } from 'shared/pages/project/sections/ps-bottom';
import VoteBlock from 'shared/pages/project/components/VoteBlock/VoteBlock';
import { MaskSwitcher } from 'shared/pages/project/components/MaskSwitcher';
import { AutoTranslateStatus } from 'shared/pages/projectEdit/types';
import { useGetCard, useGetCards } from 'shared/hooks/api/useGetCards';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import ReactTooltip from 'react-tooltip';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {isServer} from "../../constants/isServer";
import {useParamsSsr, useRouteMatchSsr} from "../../hooks/useRouteMatchSsr";
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/VotesAdminPage';
import { BlockedProjectBanner } from 'shared/pages/project/components/BlockedProjectBanner';

const getCardRoute = (ctx: string) => {
  switch(ctx) {
    case 'shopgalleryart':
      return `${process.env.REACT_APP_URL_SHOP_GALLLLERY}`
    case 'books':
      return `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}`
    case 'artzbrnd':
      return `${process.env.REACT_APP_URL_SHOP_BRANDS}`
    case 'marketartzwork':
      return `${process.env.REACT_APP_URL_ARTZ_SHOP}`
    default:
      return `${process.env.REACT_APP_URL_GALLERY}`
  }
}

const getRepRoute = (ctx: string) => {
  switch(ctx) {
    case 'artz':
      return `${process.env.REACT_APP_URL_ARTZ_SHOP}`
    case 'kids':
      return `${process.env.REACT_APP_URL_KIIIDS_ART}`
    case 'brnd':
      return `${process.env.REACT_APP_URL_SHOP_BRANDS}`
    default:
      return `${process.env.REACT_APP_URL_GALLERY}`
  }
}

//const TAGS_COUNT_IF_NEED_SCROLL = 7;

export interface ProjectDisplayLayoutProps {
  image?: ReactElement;
  firstLine?: ReactElement;
  contextName?: ReactElement;
  canViewStatus?: boolean;
  title?: ReactElement;
  author?: ReactElement;
  tags?: ReactElement[] | ReactElement;
  editorTags?: ReactElement;
  purchase?: ReactElement;
  point?: ReactElement;
  team?: ReactElement;
  dialog?: ReactElement;
  longread?: ReactElement;
  moreTitle?: ReactElement;
  studentProject?: ReactElement;
  more?: ReactElement;
  bottom?: ReactElement;
  likesSticker?: ReactElement;
  inPartCompetition?: ReactElement;
  inPartExam?: ReactElement;
  status?: ReactElement;
  placeElement?: ReactElement;
  protectStatus?: ReactElement;
  bookmarkButtonMobile?: ReactElement;
  subscribeInfo?: ReactElement;
  roomLaunchBlock?: ReactElement;
  gameInfo?: ReactElement
  queue?: ReactElement
  LMSLongreads?: ReactElement
  queueButtons?: ReactElement
  bookBuyProcessingComponent?: ReactElement
  className?: any;
  isLoading?: boolean;
  style?: any;
  project: Project;
  shouldHideTags?: boolean;
  isCollectionVote?: boolean;
  mobileOffset?: number;
  blockedState?: {
    isBlocked: boolean;
    reasons: number[];
    otherReason: string;
  };
  statusVisible?: boolean;
  showTwoColumnsCriterias?: boolean;
  isOwner?: boolean;
  bgColor?: string;
}

const ProjectLeftSectionOuterMobile = styled.div<{ isAgeytomesh?: boolean }>`
  position: relative;
  height: 100%;

  .ProjectHeaderOuterMobile {
    width: 100%;
  }

  .ProjectHeaderTitleMobile {
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
    padding: 0 10px;
    margin-top: 10px;

    @media(max-width: ${LayoutConst.screen.md}px) {
      padding-left: 0;

      ${({ isAgeytomesh }) => isAgeytomesh ? css`
        color: #545453;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
    ` : null};

    }
  }
`;

const MobileBookTitleOuter = styled(FlexBox)<{ hide?: boolean }>`
  display: flex;
  @media(max-width: ${LayoutConst.screen.md}px) {
    display: ${({ hide }) => hide ? 'none': "flex"};
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    display: flex;
  }
`;

export const VoteLongreadBlockWrapper = styled(FlexBox)`
  width: 100%;
  margin: 0 auto;
  max-width: none;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 888px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px);
  }


`;


export const BottomOuterMobile = styled.div`
  display: flex;
  width: 100%;

  .BottomOuterMobileLikes > div {
    flex-direction: row-reverse;

    > div:not(:last-child) {
      margin-left: 16px;
    }
    
    > div:first-child {
      margin-left: 8px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      > div:not(:last-child) {
        margin-left: 12px;
      }
    }
  }

  .StickyActionBarLikesControllerWrapper {
    margin-right: 8px;
  }

  .StickyActionBarShareButtonWrapper {
    margin-right: 4px;
  }

  .BottomOuterMobileActions {
    margin-left: auto;

    .MoreButtonWrapper {
      display: flex;
      padding: 0;
    }
  }
`;

export const QueueWrapper = styled(FlexBox)`
  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    padding: 0 10px;
  }
`;

const TranslatedLg = styled(FlexBox)`
    padding: 2px 8px 4px;
    background: ${({ theme }) => theme.longreadTranslated.bg};
    color: ${({ theme }) => theme.longreadTranslated.color};
    font-size: 11px;
    line-height: 13px;
    border-radius: 6px;
    gap: 4px;

    svg {
      path {
        fill: ${({ theme }) => theme.longreadTranslated.color};
      }
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      max-width: 225px;
      width: max-content;
    }
`;
const RelatedWrapper = styled(FlexBox)`
   margin-top: 16px;
   margin-bottom: 12px;
    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-top: 8px;
    }
`;
const RelatedTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 25px; /* 125% */
    letter-spacing: -0.4px;
    color: ${({ theme }) => theme.relatedTitle};
    margin-top: 32px;
    margin-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px; /* 129.412% */
        letter-spacing: -0.34px; 
        margin-bottom: 8px;
        margin-top: 0px;  
    }

`;

export const MobBottomWrapper = styled(FlexBox)<{ shouldMobOffset?: boolean }>`
    ${({ shouldMobOffset }) => 
      shouldMobOffset ? css`
        > div {
          padding-top: 24px;
        }
    ` : null};
`

const safeUseParams = isServer ? useParamsSsr : useParams
const useSafeRouteMatch = isServer ? useRouteMatchSsr : useRouteMatch
const useParamsProps = isServer ? LinkTo.project : undefined

const useBreakpoint = isServer ? () => false : useBreakpointClient;

const ProjectDisplayLayout: FC<ProjectDisplayLayoutProps> = (props) => {
  const {project, blockedState} = props
  const isMobile = useBreakpoint(940);
  const is834 = useBreakpoint(834);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const is1200 = useBreakpoint(LayoutConst.screen.l_12)
  const theme = useTheme();
  const projectIdRef = useRef<{ id: string }>(null);
  const rightSideRef = useRef<HTMLDivElement>(null);
  const { id } = safeUseParams(useParamsProps);
  const isDeziiign = AppTester.isDeziiign();
  const [collapseTags, setCollapseTags] = useState(false);
  const [showMobileTags, setShowMobileTags] = useState(false);
  const isBookMainPage = useSafeRouteMatch('/books/book');
  const isBookProjectPage = useSafeRouteMatch('/book');
  const isBookPreview = useSafeRouteMatch('/books/preview');
  const isGeograffee = AppTester.isGeograffee();
  const isOnlines = AppTester.isOnlines();
  const isBooksGallllery = AppTester.isBooksGallllery()
  //TODO: [МУСОР] разобраться и удалить
  // const isBookEditPage = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"))
  const isBookEditPage = false;
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const { t, i18n } = useTranslation();

  const isProjectCardId = useMemo(() => {
      //@ts-ignore
    return props.project?.entitiesCreators?.[0]?.entityId ?? null;
  }, [props.project]);

  const hasProductCard = useMemo(() => project?.includedCards, [project]);
  //@ts-ignore
  const isReproduction = useMemo(() => project?.includedReproductionModels, [project]); 
  const isCardOfReproduction = isReproduction?.[0]?.cardId || '';

  const { card } = useGetCard(isCardOfReproduction || isProjectCardId);
  const { cards: allCards } = useGetCards(hasProductCard, !!hasProductCard)
  
  //@ts-ignore
  const isBookProject = useMemo(() => (props.project?.isBook && props.project?.paymentType === 1), [])

  const cards = useMemo(() => isBookProject && !isBooksGallllery? [{name: 'Электронная книга', cardId: props.project?.projectId}] : allCards?.filter(x => x.statusCard == 2) ?? [], [allCards]);
  const [tags, setTags] = useState(null);
  const [isLoadingTags, setLoadingTags] = useState(false);
  useEffect(() => {
    const fetchAllTags = async () => {
      const tagIds = cards.reduce<string[]>((acc, card) => {
         //@ts-ignore
        const tagId = card?.tagIds?.[0];
        if (tagId) {
          acc.push(tagId);
        }
        return acc;
      }, []);

      if (tagIds.length === 0) return;
      setLoadingTags(true)
      try {
        const tagPromises = tagIds.map(async tagId => {
          const response = await TagsAPI.GetTag({ idTag: tagId });
          return await response.json();
        });

        const fetchedTags = await Promise.all(tagPromises);
        //@ts-ignore
        setTags(fetchedTags);
        setLoadingTags(false)
      } catch (err) {
        console.error('Error fetching tags:', err);
      } finally {
        setLoadingTags(false)
      }
    };

    fetchAllTags();
  }, [cards]); 

  //TODO: добавить поля в интерфейс Project в api, чтобы избавиться от этих тс игноров 
  

  //@ts-ignore 
  const includedCollection = useMemo(() => project?.includedCardCollectionsIds, [project]);

  //@ts-ignore
  const includedCalendar = useMemo(() => project?.includedCalendarIds, [project]);

  const isTagsButtonVisible = useMemo(() => Array.isArray(props?.tags) ? props?.tags?.length > 0 : 3, [props?.tags])

  const isBook = useMemo(() => (isBookMainPage) , [isBookMainPage ])

  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])

  const wx = useMemo(() =>  rightSideRef?.current?.clientWidth || '100%' , [rightSideRef, rightSideRef.current, isMac13, is743, isMobile, smHeight ])


  const handleOpenCardPage = () => {
    if (isReproduction?.length) {
      const baseUrl = getRepRoute(isReproduction?.[0]?.cardProviderId);
      window.open(`${baseUrl}/card/${isReproduction[0]?.cardId}`, '_blank');
    }
  };

  const handleOpenCalendarPage = () => {
    
    if (includedCalendar?.length) {
      window.open(`${process.env.REACT_APP_URL_GALLERY}/365/calendar/preview/${includedCalendar[0]}`, '_blank');
    }
  };

  const handleOpenCollectionPage = () => {
    
    if (includedCollection?.length) {
      window.open(`${process.env.REACT_APP_URL_GALLERY}/catalog/${includedCollection[0]}`, '_blank');
    }
  };

  const handleOpenProductPage = (card: any) : string => {
    const cardContext = project?.includedCardModels?.[0]?.['contexts']?.[0] || ''
    if (isBookProject) {
      return `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}/book/${props.project?.projectId}`
    }
    if (hasProductCard?.length) {
      const cardId = card.cardId
      let baseUrl = getCardRoute(cardContext)
      return `${baseUrl}/card/${cardId}`
    }
    return ''
  };

  const formatSequenceNumber = (sequenceNumber?: string): string => {
    if (!sequenceNumber) return '';
    
    const letters = sequenceNumber.match(/^[A-Za-z]+/)?.[0] || '';
    const digits = sequenceNumber.replace(letters, '').substring(0, 4);
    
    return `${letters} ${digits}`; 
  };

  const viewType = vtype || 'container';

  const isPreview = !!useRouteMatch("/preview");

  const isMaskSwitcherVisibile = useMemo(
    () => (
      (props.project?.book && 
        !!props.project?.book?.isProtected && 
        (isPreview || isBookPreview) && 
        !!props.canViewStatus)
      ) , [props, isPreview, isBookPreview])

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDesign = AppTester.isDeziiign();
  const isHseDesign = AppTester.isHSEDesign();
  const isSuperPuper = AppTester.isSuperPuper();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isContinuumSite = AppTester.isContinuumSite();
  const isCompetition = AppTester.isCompetition();
  const isDafes = AppTester.isGeoDafes();

  const maxTagHeight = (isMac13 || smHeight) ? 140 : 162;

  useEffect(() => {
    setTimeout(() => {
      if (projectIdRef.current === id ) {
        const tagsContainer = document.querySelector(is743 ? '#mobile-tags-container' : '#tags_container');

        if (tagsContainer) {
          //@ts-ignore
          if (tagsContainer.offsetHeight > maxTagHeight) {
            setCollapseTags(true);
          }
        }
      }
    } , 100)
       
  },[maxTagHeight, isBookEditPage, projectIdRef, id, showMobileTags, is743]);


  //@ts-ignore
  projectIdRef.current = id;

  const handleToggleMobileTagClick = useCallback((flag: boolean) => setShowMobileTags(flag),  [])

  const calculateGradientColor = useMemo(() => {
    if (props.bgColor) {
      return props.bgColor
    }
    if (isSuperPuper || isCGrave || isContinuumSite || isAdcrDafesNet) {
      return '#000000';
    }
    if (isDesign || isHseDesign || isCompetition || isDafes ) {
      if (isBookEditPage || isMobile) return Colors.gal
      //@ts-ignore
      return props?.project?.additionalInfo?.color || Colors.gal
    }
    return Colors.geo; 
  }, [props?.project, isHseDesign, isDesign, isCompetition, isCGrave, isAdcrDafesNet , isContinuumSite, isMobile])

  const tagsGradientColor = calculateGradientColor;
  const showHeaderOnTop = useMemo(() => (!props?.isCollectionVote), [props?.isCollectionVote])
  const isBookChapter = useMemo(() => (isBookPreview || props?.project?.book || (isPreview && !!props.project?.book)), [isBookPreview, isPreview, props.project])

  //Уберу , когда закончу с книгами @Artem
  const showDespLayout = useMemo(() => {
    if (isOnlines && !isMobile) return true;
    if (!isOnlines && !is743) return true;
    return false
  }, [isMobile, isOnlines, is744, is743, is834, isBook])


  //Уберу , когда закончу с книгами @Artem
  const showMobLayout = useMemo(() => {
    if (isOnlines && isMobile) return true;
    if (!isOnlines && is743) return true;
    return false
  }, [isOnlines, isMobile, is744, is834, is743, isBook ])
    const isCollectionVote = project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)

  return (
    <FlexBox direction="column" directionMobile="column">
        {props.project && <BlockedProjectBanner 
          project={props.project} 
          isTemporaryBlocked={blockedState?.isBlocked}
          temporaryBlockingReasons={blockedState?.reasons}
          temporaryOtherReason={blockedState?.otherReason}
        />}
        {showDespLayout && (
        <ProjectContainerLayout
          isProjectPage={!isBookMainPage && !isOnlines}
          isBookMainPage={!!isBookMainPage}
          isCollectionVote={isCollectionVote}
          header={<>
            {showHeaderOnTop && 
              <ProjectHeader 
                project={props.project} 
                fireClick={isPreview} 
                isProjectPage={!isBookMainPage && !isOnlines} 
                isBookPage={!!isBookMainPage} 
              />}
            </>}
          rightSide={
            <FlexBox
              direction="column"
              directionMobile="column"
              justify="space-between"
              width="100%"
              ref={rightSideRef}
              height="100%"
              style={{position: 'relative'}}
            >
              {!isMobile && props.placeElement && <div style={{position: 'absolute', right: is1200 ? '-34px' : '-64px'}}>{props.placeElement}</div>}
              <FlexBox direction="column" directionMobile='column'>
                {props?.bookBuyProcessingComponent ? props?.bookBuyProcessingComponent :  isDeziiign ? (
                  <>
                    <FlexBox offsetBottom={24} gy={isBookChapter ? 0 : 8} direction={'column'} directionMobile='column' justify="space-between" align="flex-start">
                      {isBookChapter && (
                        <FlexBox width={'100%'} offsetBottom={16}>
                          <MainBookTitle book={props.project} />
                        </FlexBox>
                      )}
                      {props.isLoading ? (
                        <Skeleton
                          style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                          width={wx}
                          height={64}
                        />
                      ) : (
                        <FlexBox>
                          {props.title}
                        </FlexBox>
                      )}
                      {/* @ts-ignore */}
                     {!props.isOwner && i18n.language === 'en' && props.project?.autoTranslateStatus === AutoTranslateStatus.Complete && <TranslatedLg offsetTop={16}><span>{t('project_edit.lg_automatically_translated')}</span>
                      <span style={{marginTop: '-2px'}}><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.2241e-08 5.20356C5.2241e-08 5.40902 0.132188 5.59169 0.327656 5.65525L2.39344 6.32659L3.06422 8.39139C3.09525 8.48666 3.15563 8.56967 3.23671 8.62854C3.3178 8.6874 3.41543 8.7191 3.51562 8.7191C3.61582 8.7191 3.71345 8.6874 3.79454 8.62854C3.87562 8.56967 3.936 8.48666 3.96703 8.39139L4.63922 6.32659L6.70359 5.65525C6.79887 5.62418 6.88187 5.56377 6.94072 5.48266C6.99957 5.40156 7.03126 5.30391 7.03125 5.2037C7.03125 4.99811 6.89906 4.81572 6.70359 4.75216L4.63922 4.08081L3.96703 2.01602C3.93607 1.92067 3.87572 1.83758 3.79463 1.77866C3.71354 1.71973 3.61587 1.68799 3.51562 1.68799C3.41538 1.68799 3.31771 1.71973 3.23662 1.77866C3.15553 1.83758 3.09518 1.92067 3.06422 2.01602L2.39344 4.08081L0.327656 4.75216C0.232373 4.78316 0.149351 4.84354 0.0904903 4.92463C0.0316299 5.00572 -4.69545e-05 5.10336 5.2241e-08 5.20356Z" fill="#909090"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.15781 0.194686C7.13961 0.138136 7.10394 0.0888189 7.05592 0.0538339C7.00791 0.018849 6.95003 0 6.89062 0C6.83122 0 6.77334 0.018849 6.72533 0.0538339C6.67731 0.0888189 6.64164 0.138136 6.62344 0.194686L6.21844 1.43795L4.97531 1.84225C4.86 1.87994 4.78125 1.98794 4.78125 2.10972C4.78125 2.2315 4.86 2.3395 4.97531 2.37719L6.21844 2.78148L6.62344 4.02475C6.64164 4.0813 6.67731 4.13061 6.72533 4.1656C6.77334 4.20058 6.83122 4.21943 6.89062 4.21943C6.95003 4.21943 7.00791 4.20058 7.05592 4.1656C7.10394 4.13061 7.13961 4.0813 7.15781 4.02475L7.56281 2.78148L8.80594 2.37719C8.92125 2.3395 9 2.2315 9 2.10972C9 1.98794 8.92125 1.87994 8.80594 1.84225L7.56281 1.43795L7.15781 0.194686Z" fill="#909090"/>
                      </svg></span>
                      </TranslatedLg>} 
                      {props?.firstLine && (
                        <FlexBox>
                            {props.firstLine}
                        </FlexBox>
                      )}
                    </FlexBox>

                    {props.isLoading ? (
                      <Skeleton
                        style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                        width={wx}
                        height={57}
                      />
                    ) : (
                        <>
                          {
                            <FlexBox direction='column' directionMobile='column' style={{ position: 'relative' }}>
                              <FlexBox gx={16} gxMobile={8} width="100%">
                                {/* @ts-ignore */}
                                <BTagsGridNew id="tags_container" gap={10} scroll={collapseTags} shadow isProjectPage>
                                  {props.tags}
                                </BTagsGridNew>
                                {props?.editorTags || null}
                              </FlexBox>
                              {props.protectStatus}
                              {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length) ? (
                                  <RelatedWrapper direction='column'>
                                    <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                                    <FlexBox wrap='wrap' >
                                      {!!cards?.length && !isLoadingTags && (
                                        cards.map((card, index) => {                                         
                                          return <span style={{ marginRight: '8px', marginBottom: '8px' }} {...{
                                              'data-tip': card.name,
                                              'data-for': card.cardId
                                            }}>
                                              <a href={handleOpenProductPage(card)} target='_blank'><BTag>{isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}</BTag></a>
                                              <ReactTooltip {...getTooltipStyles(theme)} {...{id: card.cardId, className: card.cardId}} />
                                            </span>
                                        })
                                      )}
                                      {!!isReproduction?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCardPage}>{t('reproductions')}</BTag></span>
                                      )}
                                      {!!includedCollection?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                      )}
                                      {!!includedCalendar?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                      )}
                                    </FlexBox>
                                  </RelatedWrapper>
                                ) : null
                              }

                            </FlexBox>
                          }
                        </>
                    )}
                  </>
                ) : (
                  <>
                    <FlexBox offsetBottom={(isMac13 && !isBookMainPage) ? 16 : !!isBookMainPage ? 24 : 16} gx={0} direction={'column'} directionMobile='column' justify="space-between" align="flex-start">
                      {isBookChapter && (
                        <FlexBox width={'100%'} offsetBottom={16}>
                          <MainBookTitle book={props.project} />
                        </FlexBox>
                      )}
                      <FlexBox offsetBottom={24} gx={8} justify="space-between" align="flex-start" width={'100%'}>
                        {props.isLoading ? (
                          <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={wx}
                            height={64}
                          />
                        ) : (
                          <FlexBox>
                            {props.title}
                          </FlexBox>
                        )}
                        {props?.firstLine && (
                          <FlexBox>
                            {props.firstLine}
                          </FlexBox>
                        )} 
                      </FlexBox>
                      <FlexBox width={'100%'}>
                        {props.isLoading ? (
                          <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={wx}
                            height={57}
                          />
                        ) : (
                          <FlexBox direction='column'>
                          {/*@ts-ignore*/}
                            <BTagsGridNew id={'tags_container'} gap={10} scrollMode="all" shadow>
                              {props.tags}
                            </BTagsGridNew>
                            {props.protectStatus}
                            {!!props.statusVisible && (
                              <FlexBox offsetTop={52}>
                                {props.status}
                              </FlexBox>
                            )}
                          </FlexBox>
                        )}
                      </FlexBox>
                      {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length) ? (
                          <RelatedWrapper direction='column'>
                            <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                              <FlexBox wrap='wrap' >
                                {!!cards?.length && (
                                  cards.map((card, index) => {
                                          
                                    return <span style={{ marginRight: '8px', marginBottom: '8px' }} {...{
                                      'data-tip': card.name,
                                      'data-for': card.cardId
                                      }}>
                                  {/*@ts-ignore*/}
                                  <a href={handleOpenProductPage(card)} target='_blank'><BTag>{isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}</BTag></a>
                                  <ReactTooltip {...getTooltipStyles(theme)} {...{id: card.cardId, className: card.cardId}} />
                                  </span>
                                  })
                                )}
                                {!!isReproduction?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCardPage}>{t('reproductions')}</BTag></span>
                                )}
                                {!!includedCollection?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                )}
                                {!!includedCalendar?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                )}
                              </FlexBox>
                            </RelatedWrapper>
                          ) : null
                        }
                    </FlexBox>
                  </>
                )}
              </FlexBox>
              <FlexBox>
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                    width={wx}
                    height={32}
                  />
                ) : (
                  <FlexBox direction={isMaskSwitcherVisibile ? 'row' : 'column'} directionMobile={isMaskSwitcherVisibile ? 'row' : 'column'} width={'100%'}>
                    {props.bottom}
                    {isMaskSwitcherVisibile && <MaskSwitcher project={props?.project} />}
                  </FlexBox>
                )}
                {props.queueButtons}
              </FlexBox>
            </FlexBox>
          }
          leftSide={
            <ProjectImageWrapper isProjectPage={!isBookMainPage && !isOnlines} isBooks={!!isBookMainPage}>
              {isMobile && props.placeElement && <div style={{position: 'absolute', left: '10px', top: '-3px'}}>{props.placeElement}</div>}
              {props.isLoading ? (
                <Skeleton
                  style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                  width="100%"
                  height="100%"
                />
              ) : (
                props.image
              )}
            </ProjectImageWrapper>
          }
        />
      )}

      {showMobLayout && (
        <ProjectContainerLayout
          isBookMainPage={!!isBookMainPage}
          rightSide={

            <FlexBox direction="column" directionMobile="column" width="100%" ref={rightSideRef}>
              {isBookMainPage && isMobile && !is743 && (
                <div className="ProjectHeaderOuterMobile">
                  <div className="ProjectHeaderTitleMobile">
                    {props.title}
                  </div>
                </div>
              )}
              {!!isBookMainPage && isMobile && !is743 ? (
                <FlexBox offsetTopMobile={24}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={57}
                    />
                  ) : (
                    <FlexBox direction='column'>
                      <BTagsGridNew id="tags_container" scrollMode="all" shadow>
                        {props.tags}
                      </BTagsGridNew>
                      <FlexBox offsetTop={52}>
                        {props.status}
                      </FlexBox>
                    </FlexBox>
                  )}
                </FlexBox>
              ) : (
                <FlexBox offsetTop={isMobile ? 24 : 24}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={32}
                    />
                  ) : (
                    <BottomOuterMobile>
                      <div className="BottomOuterMobileLikes">
                        {props.likesSticker}
                      </div>

                      <div className="BottomOuterMobileActions">
                        <FlexBox directionMobile="row" gxMobile={12}>
                          {isTagsButtonVisible && <TagsMobBtn onClick={handleToggleMobileTagClick} flag={showMobileTags} />}
                        </FlexBox>
                      </div>
                    </BottomOuterMobile>
                  )}
                </FlexBox>
              )}
              {isBookMainPage && isMobile && (
                <FlexBox offsetTopMobile={isBookMainPage && isMobile && !is743 ? 'auto' : 0}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={32}
                    />
                  ) : (
                    <FlexBox direction='column' directionMobile='column' width={'100%'}>
                      {props.bottom}
                    </FlexBox>
                  )}
                </FlexBox>
              )}

              {(props.firstLine || props.isLoading) && (
                <FlexBox offsetTop={25}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={40}
                    />
                  ) : (
                    props.firstLine
                  )}
                </FlexBox>
              )}

              <FlexBox offsetTop={(props.isLoading || showMobileTags) ? 24 : 0}>
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor, marginBottom: '14px' }}
                    width={wx}
                    height={57}
                  />
                ) : (
                  <>
                    <MobBottomWrapper 
                      directionMobile="column"
                      widthMobile={'100%'} 
                      shouldMobOffset={
                        isGeograffee && 
                        props.point && 
                        !showMobileTags
                      }
                    >
                      {props.purchase}
                      {showMobileTags && (
                        <>
                          <FlexBox gx={16} gxMobile={8} width="100%">
                            <TagsMobile show={showMobileTags} scroll={collapseTags} background={tagsGradientColor}>
                              {props.tags}
                            </TagsMobile>
                            {props?.editorTags || null}
                          </FlexBox>

                      </>
                      )}
                      {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length)? (
                            <RelatedWrapper direction="column">
                              <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                              <FlexBox wrap="wrap">
                                {!!cards?.length && cards.map((card, index) => (
                                  <span
                                    key={card.cardId}
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                    data-tip={card.name}
                                    data-for={card.cardId}
                                  >
                                    <a href={handleOpenProductPage(card)} target='_blank'><BTag>
                                      {isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}
                                    </BTag></a>
                                    <ReactTooltip
                                      {...getTooltipStyles(theme)}
                                      id={card.cardId}
                                      className={card.cardId}
                                    />
                                  </span>
                                ))}
                                {!!isReproduction?.length && (
                                  <span style={{ marginRight: 8, marginBottom: 8 }}>
                                    <BTag onClick={handleOpenCardPage}>
                                      {t('reproductions')}
                                    </BTag>
                                  </span>
                                )}
                                {!!includedCollection?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                )}
                                {!!includedCalendar?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                )}
                              </FlexBox>
                            </RelatedWrapper>
                          ) : undefined}
                      {isMaskSwitcherVisibile && <MaskSwitcher project={props?.project} minOffset={showMobileTags} />}
                    </MobBottomWrapper>
                  </>
                )}
              </FlexBox>
              {/* @ts-ignore */}
              {!props.isOwner && i18n.language === 'en' && props.project?.autoTranslateStatus === AutoTranslateStatus.Complete && <TranslatedLg offsetTop={16}><span>{t('project_edit.lg_automatically_translated')}</span>
                      <span style={{marginTop: '-2px'}}><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.2241e-08 5.20356C5.2241e-08 5.40902 0.132188 5.59169 0.327656 5.65525L2.39344 6.32659L3.06422 8.39139C3.09525 8.48666 3.15563 8.56967 3.23671 8.62854C3.3178 8.6874 3.41543 8.7191 3.51562 8.7191C3.61582 8.7191 3.71345 8.6874 3.79454 8.62854C3.87562 8.56967 3.936 8.48666 3.96703 8.39139L4.63922 6.32659L6.70359 5.65525C6.79887 5.62418 6.88187 5.56377 6.94072 5.48266C6.99957 5.40156 7.03126 5.30391 7.03125 5.2037C7.03125 4.99811 6.89906 4.81572 6.70359 4.75216L4.63922 4.08081L3.96703 2.01602C3.93607 1.92067 3.87572 1.83758 3.79463 1.77866C3.71354 1.71973 3.61587 1.68799 3.51562 1.68799C3.41538 1.68799 3.31771 1.71973 3.23662 1.77866C3.15553 1.83758 3.09518 1.92067 3.06422 2.01602L2.39344 4.08081L0.327656 4.75216C0.232373 4.78316 0.149351 4.84354 0.0904903 4.92463C0.0316299 5.00572 -4.69545e-05 5.10336 5.2241e-08 5.20356Z" fill="#909090"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.15781 0.194686C7.13961 0.138136 7.10394 0.0888189 7.05592 0.0538339C7.00791 0.018849 6.95003 0 6.89062 0C6.83122 0 6.77334 0.018849 6.72533 0.0538339C6.67731 0.0888189 6.64164 0.138136 6.62344 0.194686L6.21844 1.43795L4.97531 1.84225C4.86 1.87994 4.78125 1.98794 4.78125 2.10972C4.78125 2.2315 4.86 2.3395 4.97531 2.37719L6.21844 2.78148L6.62344 4.02475C6.64164 4.0813 6.67731 4.13061 6.72533 4.1656C6.77334 4.20058 6.83122 4.21943 6.89062 4.21943C6.95003 4.21943 7.00791 4.20058 7.05592 4.1656C7.10394 4.13061 7.13961 4.0813 7.15781 4.02475L7.56281 2.78148L8.80594 2.37719C8.92125 2.3395 9 2.2315 9 2.10972C9 1.98794 8.92125 1.87994 8.80594 1.84225L7.56281 1.43795L7.15781 0.194686Z" fill="#909090"/>
                      </svg></span>
                      </TranslatedLg>} 
            </FlexBox>
          }
          leftSide={
            <ProjectLeftSectionOuterMobile isAgeytomesh={isAgeytomesh}>
                <MobileBookTitleOuter hide={!!isBookMainPage}>
                  {props?.contextName && props?.contextName}
                  <div className="ProjectHeaderOuterMobile">
                    {isBookChapter ? (
                      <FlexBox width={'100%'} offsetBottomMobile={16}>
                        <MainBookTitle book={props.project} />
                      </FlexBox>
                    ) : (
                      !isSuperPuper && <ProjectHeader project={props.project} fireClick={isPreview} />
                    )}
                    <div className="ProjectHeaderTitleMobile">
                      {props.title}
                    </div>
                  </div>
                </MobileBookTitleOuter>

              <ProjectImageWrapper isProjectPage={!!isBookMainPage}>
                {props.bookmarkButtonMobile}
                {props.placeElement && <div style={{position: 'absolute', right: '10px', top: '-3px'}}>{props.placeElement}</div>}
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                    width="100%"
                    height="100%"
                  />
                ) : (
                  props.image
                )}
              </ProjectImageWrapper>
            </ProjectLeftSectionOuterMobile>
          }
        />
      )}

      {props.gameInfo}
      {showMobLayout && !isBookMainPage && <>
        <FlexBox width="100%" direction="column" directionMobile="column" align="center">
          {props.bookBuyProcessingComponent && <FlexBox width="calc(100% - 20px)" offsetBottom={16}>
            {props.bookBuyProcessingComponent}
          </FlexBox>}
          {props.bottom}
        </FlexBox>
      </>}
      {props.inPartExam}
      {props.studentProject}
      {props.inPartCompetition}
      {!props.project?.isBook && (
        <VoteLongreadBlockWrapper justify='center' align='center'>

            <VoteBlock project={props.project} fullSize position={VOTE_BLOCK_POSITION.longread} />

        </VoteLongreadBlockWrapper>
      )}

      {props?.queue && <QueueWrapper width="100%" offsetTop={24} justify="center">
        {props?.queue}
      </QueueWrapper>}

      {props.subscribeInfo && (
        <FlexBox>
          {props.subscribeInfo}
        </FlexBox>
      )}

      {props.roomLaunchBlock && (
        <FlexBox offsetTop={40} offsetTopMobile={20} offsetBottomMobile={20}>
          {props.roomLaunchBlock}
        </FlexBox>
      )}

      <ProjectLongreadWrapper showTags={showMobileTags} vtype={viewType} isBooks={!!isBookMainPage || !!isBookProjectPage}>
        {props.isLoading ? <Skeleton style={{ marginLeft: 'auto', marginRight: 'auto' }} offsetTop={24} offsetTopMobile={8} width="100%" widthMobile={is743 ? 'calc(100% - 20px)' : '100%'} height={100}/> : props.longread}
        {props.LMSLongreads}
      </ProjectLongreadWrapper>

      <VoteLongreadBlockWrapper justify='center' align='center'>

          <VoteBlock project={props.project} fullSize position={VOTE_BLOCK_POSITION.bottom} />

      </VoteLongreadBlockWrapper>
    </FlexBox>
  );
};

export default memo(ProjectDisplayLayout);
import { FC, memo, ReactElement, useEffect, useCallback, useMemo, useRef, useState } from 'react';
import { Colors, FlexBox, Skeleton, useBreakpoint as useBreakpointClient } from '@brg/ui';
import styled, { useTheme, css } from 'styled-components';
import { API, Project, Tag, TagsAPI } from '@brg/api';
import { AppTester } from '../../../supporting';
import { ProjectImageWrapper, ProjectLongreadWrapper } from '../../pages/project/styles';
import { ProjectContainerLayout } from './project-container-layout';
import ProjectHeader from '../../pages/project/components/ProjectHeader';
import TagsMobile from "../../pages/project/components/TagsMobile";
import { BTag } from "../../../core/components";
import { LayoutConst } from "../../../core";
import { useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {LinkTo} from 'shared/constants/linkTo';
import { MainBookTitle } from '_deziiign/books/pages/BookView/components/MainBookTitle';
import { TagsMobBtn } from '../TagsMobBtn/TagsMobBtn';
import { useSelector } from "react-redux";
import { VOTE_BLOCK_POSITION } from 'shared/pages/project/sections/ps-bottom';
import VoteBlock from 'shared/pages/project/components/VoteBlock/VoteBlock';
import { MaskSwitcher } from 'shared/pages/project/components/MaskSwitcher';
import { AutoTranslateStatus } from 'shared/pages/projectEdit/types';
import { useGetCard, useGetCards } from 'shared/hooks/api/useGetCards';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import ReactTooltip from 'react-tooltip';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {isServer} from "../../constants/isServer";
import {useParamsSsr, useRouteMatchSsr} from "../../hooks/useRouteMatchSsr";
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/VotesAdminPage';
import { BlockedProjectBanner } from 'shared/pages/project/components/BlockedProjectBanner';

const getCardRoute = (ctx: string) => {
  switch(ctx) {
    case 'shopgalleryart':
      return `${process.env.REACT_APP_URL_SHOP_GALLLLERY}`
    case 'books':
      return `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}`
    case 'artzbrnd':
      return `${process.env.REACT_APP_URL_SHOP_BRANDS}`
    case 'marketartzwork':
      return `${process.env.REACT_APP_URL_ARTZ_SHOP}`
    default:
      return `${process.env.REACT_APP_URL_GALLERY}`
  }
}

const getRepRoute = (ctx: string) => {
  switch(ctx) {
    case 'artz':
      return `${process.env.REACT_APP_URL_ARTZ_SHOP}`
    case 'kids':
      return `${process.env.REACT_APP_URL_KIIIDS_ART}`
    case 'brnd':
      return `${process.env.REACT_APP_URL_SHOP_BRANDS}`
    default:
      return `${process.env.REACT_APP_URL_GALLERY}`
  }
}

//const TAGS_COUNT_IF_NEED_SCROLL = 7;

export interface ProjectDisplayLayoutProps {
  image?: ReactElement;
  firstLine?: ReactElement;
  contextName?: ReactElement;
  canViewStatus?: boolean;
  title?: ReactElement;
  author?: ReactElement;
  tags?: ReactElement[] | ReactElement;
  editorTags?: ReactElement;
  purchase?: ReactElement;
  point?: ReactElement;
  team?: ReactElement;
  dialog?: ReactElement;
  longread?: ReactElement;
  moreTitle?: ReactElement;
  studentProject?: ReactElement;
  more?: ReactElement;
  bottom?: ReactElement;
  likesSticker?: ReactElement;
  inPartCompetition?: ReactElement;
  inPartExam?: ReactElement;
  status?: ReactElement;
  placeElement?: ReactElement;
  protectStatus?: ReactElement;
  bookmarkButtonMobile?: ReactElement;
  subscribeInfo?: ReactElement;
  roomLaunchBlock?: ReactElement;
  gameInfo?: ReactElement
  queue?: ReactElement
  LMSLongreads?: ReactElement
  queueButtons?: ReactElement
  bookBuyProcessingComponent?: ReactElement
  className?: any;
  isLoading?: boolean;
  style?: any;
  project: Project;
  shouldHideTags?: boolean;
  isCollectionVote?: boolean;
  mobileOffset?: number;
  blockedState?: {
    isBlocked: boolean;
    reasons: number[];
    otherReason: string;
  };
  statusVisible?: boolean;
  showTwoColumnsCriterias?: boolean;
  isOwner?: boolean;
  bgColor?: string;
}

const ProjectLeftSectionOuterMobile = styled.div<{ isAgeytomesh?: boolean }>`
  position: relative;
  height: 100%;

  .ProjectHeaderOuterMobile {
    width: 100%;
  }

  .ProjectHeaderTitleMobile {
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
    padding: 0 10px;
    margin-top: 10px;

    @media(max-width: ${LayoutConst.screen.md}px) {
      padding-left: 0;

      ${({ isAgeytomesh }) => isAgeytomesh ? css`
        color: #545453;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
    ` : null};

    }
  }
`;

const MobileBookTitleOuter = styled(FlexBox)<{ hide?: boolean }>`
  display: flex;
  @media(max-width: ${LayoutConst.screen.md}px) {
    display: ${({ hide }) => hide ? 'none': "flex"};
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    display: flex;
  }
`;

export const VoteLongreadBlockWrapper = styled(FlexBox)`
  width: 100%;
  margin: 0 auto;
  max-width: none;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 888px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px);
  }


`;


export const BottomOuterMobile = styled.div`
  display: flex;
  width: 100%;

  .BottomOuterMobileLikes > div {
    flex-direction: row-reverse;

    > div:not(:last-child) {
      margin-left: 16px;
    }
    
    > div:first-child {
      margin-left: 8px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      > div:not(:last-child) {
        margin-left: 12px;
      }
    }
  }

  .StickyActionBarLikesControllerWrapper {
    margin-right: 8px;
  }

  .StickyActionBarShareButtonWrapper {
    margin-right: 4px;
  }

  .BottomOuterMobileActions {
    margin-left: auto;

    .MoreButtonWrapper {
      display: flex;
      padding: 0;
    }
  }
`;

export const QueueWrapper = styled(FlexBox)`
  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    padding: 0 10px;
  }
`;

const TranslatedLg = styled(FlexBox)`
    padding: 2px 8px 4px;
    background: ${({ theme }) => theme.longreadTranslated.bg};
    color: ${({ theme }) => theme.longreadTranslated.color};
    font-size: 11px;
    line-height: 13px;
    border-radius: 6px;
    gap: 4px;

    svg {
      path {
        fill: ${({ theme }) => theme.longreadTranslated.color};
      }
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      max-width: 225px;
      width: max-content;
    }
`;
const RelatedWrapper = styled(FlexBox)`
   margin-top: 16px;
   margin-bottom: 12px;
    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-top: 8px;
    }
`;
const RelatedTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 25px; /* 125% */
    letter-spacing: -0.4px;
    color: ${({ theme }) => theme.relatedTitle};
    margin-top: 32px;
    margin-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px; /* 129.412% */
        letter-spacing: -0.34px; 
        margin-bottom: 8px;
        margin-top: 0px;  
    }

`;

export const MobBottomWrapper = styled(FlexBox)<{ shouldMobOffset?: boolean }>`
    ${({ shouldMobOffset }) => 
      shouldMobOffset ? css`
        > div {
          padding-top: 24px;
        }
    ` : null};
`

const safeUseParams = isServer ? useParamsSsr : useParams
const useSafeRouteMatch = isServer ? useRouteMatchSsr : useRouteMatch
const useParamsProps = isServer ? LinkTo.project : undefined

const useBreakpoint = isServer ? () => false : useBreakpointClient;

const ProjectDisplayLayout: FC<ProjectDisplayLayoutProps> = (props) => {
  const {project, blockedState} = props
  const isMobile = useBreakpoint(940);
  const is834 = useBreakpoint(834);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const is1200 = useBreakpoint(LayoutConst.screen.l_12)
  const theme = useTheme();
  const projectIdRef = useRef<{ id: string }>(null);
  const rightSideRef = useRef<HTMLDivElement>(null);
  const { id } = safeUseParams(useParamsProps);
  const isDeziiign = AppTester.isDeziiign();
  const [collapseTags, setCollapseTags] = useState(false);
  const [showMobileTags, setShowMobileTags] = useState(false);
  const isBookMainPage = useSafeRouteMatch('/books/book');
  const isBookProjectPage = useSafeRouteMatch('/book');
  const isBookPreview = useSafeRouteMatch('/books/preview');
  const isGeograffee = AppTester.isGeograffee();
  const isOnlines = AppTester.isOnlines();
  const isBooksGallllery = AppTester.isBooksGallllery()
  //TODO: [МУСОР] разобраться и удалить
  // const isBookEditPage = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"))
  const isBookEditPage = false;
  const vtype = useSelector((state: any) => state.vt.projectVType);
  const { t, i18n } = useTranslation();

  const isProjectCardId = useMemo(() => {
      //@ts-ignore
    return props.project?.entitiesCreators?.[0]?.entityId ?? null;
  }, [props.project]);

  const hasProductCard = useMemo(() => project?.includedCards, [project]);
  //@ts-ignore
  const isReproduction = useMemo(() => project?.includedReproductionModels, [project]); 
  const isCardOfReproduction = isReproduction?.[0]?.cardId || '';

  const { card } = useGetCard(isCardOfReproduction || isProjectCardId);
  const { cards: allCards } = useGetCards(hasProductCard, !!hasProductCard)
  
  //@ts-ignore
  const isBookProject = useMemo(() => (props.project?.isBook && props.project?.paymentType === 1), [])

  const cards = useMemo(() => isBookProject && !isBooksGallllery? [{name: 'Электронная книга', cardId: props.project?.projectId}] : allCards?.filter(x => x.statusCard == 2) ?? [], [allCards]);
  const [tags, setTags] = useState(null);
  const [isLoadingTags, setLoadingTags] = useState(false);
  useEffect(() => {
    const fetchAllTags = async () => {
      const tagIds = cards.reduce<string[]>((acc, card) => {
         //@ts-ignore
        const tagId = card?.tagIds?.[0];
        if (tagId) {
          acc.push(tagId);
        }
        return acc;
      }, []);

      if (tagIds.length === 0) return;
      setLoadingTags(true)
      try {
        const tagPromises = tagIds.map(async tagId => {
          const response = await TagsAPI.GetTag({ idTag: tagId });
          return await response.json();
        });

        const fetchedTags = await Promise.all(tagPromises);
        //@ts-ignore
        setTags(fetchedTags);
        setLoadingTags(false)
      } catch (err) {
        console.error('Error fetching tags:', err);
      } finally {
        setLoadingTags(false)
      }
    };

    fetchAllTags();
  }, [cards]); 

  //TODO: добавить поля в интерфейс Project в api, чтобы избавиться от этих тс игноров 
  

  //@ts-ignore 
  const includedCollection = useMemo(() => project?.includedCardCollectionsIds, [project]);

  //@ts-ignore
  const includedCalendar = useMemo(() => project?.includedCalendarIds, [project]);

  const isTagsButtonVisible = useMemo(() => Array.isArray(props?.tags) ? props?.tags?.length > 0 : 3, [props?.tags])

  const isBook = useMemo(() => (isBookMainPage) , [isBookMainPage ])

  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])

  const wx = useMemo(() =>  rightSideRef?.current?.clientWidth || '100%' , [rightSideRef, rightSideRef.current, isMac13, is743, isMobile, smHeight ])


  const handleOpenCardPage = () => {
    if (isReproduction?.length) {
      const baseUrl = getRepRoute(isReproduction?.[0]?.cardProviderId);
      window.open(`${baseUrl}/card/${isReproduction[0]?.cardId}`, '_blank');
    }
  };

  const handleOpenCalendarPage = () => {
    
    if (includedCalendar?.length) {
      window.open(`${process.env.REACT_APP_URL_GALLERY}/365/calendar/preview/${includedCalendar[0]}`, '_blank');
    }
  };

  const handleOpenCollectionPage = () => {
    
    if (includedCollection?.length) {
      window.open(`${process.env.REACT_APP_URL_GALLERY}/catalog/${includedCollection[0]}`, '_blank');
    }
  };

  const handleOpenProductPage = (card: any) : string => {
    const cardContext = project?.includedCardModels?.[0]?.['contexts']?.[0] || ''
    if (isBookProject) {
      return `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}/book/${props.project?.projectId}`
    }
    if (hasProductCard?.length) {
      const cardId = card.cardId
      let baseUrl = getCardRoute(cardContext)
      return `${baseUrl}/card/${cardId}`
    }
    return ''
  };

  const formatSequenceNumber = (sequenceNumber?: string): string => {
    if (!sequenceNumber) return '';
    
    const letters = sequenceNumber.match(/^[A-Za-z]+/)?.[0] || '';
    const digits = sequenceNumber.replace(letters, '').substring(0, 4);
    
    return `${letters} ${digits}`; 
  };

  const viewType = vtype || 'container';

  const isPreview = !!useRouteMatch("/preview");

  const isMaskSwitcherVisibile = useMemo(
    () => (
      (props.project?.book && 
        !!props.project?.book?.isProtected && 
        (isPreview || isBookPreview) && 
        !!props.canViewStatus)
      ) , [props, isPreview, isBookPreview])

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDesign = AppTester.isDeziiign();
  const isHseDesign = AppTester.isHSEDesign();
  const isSuperPuper = AppTester.isSuperPuper();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isContinuumSite = AppTester.isContinuumSite();
  const isCompetition = AppTester.isCompetition();
  const isDafes = AppTester.isGeoDafes();

  const maxTagHeight = (isMac13 || smHeight) ? 140 : 162;

  useEffect(() => {
    setTimeout(() => {
      if (projectIdRef.current === id ) {
        const tagsContainer = document.querySelector(is743 ? '#mobile-tags-container' : '#tags_container');

        if (tagsContainer) {
          //@ts-ignore
          if (tagsContainer.offsetHeight > maxTagHeight) {
            setCollapseTags(true);
          }
        }
      }
    } , 100)
       
  },[maxTagHeight, isBookEditPage, projectIdRef, id, showMobileTags, is743]);


  //@ts-ignore
  projectIdRef.current = id;

  const handleToggleMobileTagClick = useCallback((flag: boolean) => setShowMobileTags(flag),  [])

  const calculateGradientColor = useMemo(() => {
    if (props.bgColor) {
      return props.bgColor
    }
    if (isSuperPuper || isCGrave || isContinuumSite || isAdcrDafesNet) {
      return '#000000';
    }
    if (isDesign || isHseDesign || isCompetition || isDafes ) {
      if (isBookEditPage || isMobile) return Colors.gal
      //@ts-ignore
      return props?.project?.additionalInfo?.color || Colors.gal
    }
    return Colors.geo; 
  }, [props?.project, isHseDesign, isDesign, isCompetition, isCGrave, isAdcrDafesNet , isContinuumSite, isMobile])

  const tagsGradientColor = calculateGradientColor;
  const showHeaderOnTop = useMemo(() => (!props?.isCollectionVote), [props?.isCollectionVote])
  const isBookChapter = useMemo(() => (isBookPreview || props?.project?.book || (isPreview && !!props.project?.book)), [isBookPreview, isPreview, props.project])

  //Уберу , когда закончу с книгами @Artem
  const showDespLayout = useMemo(() => {
    if (isOnlines && !isMobile) return true;
    if (!isOnlines && !is743) return true;
    return false
  }, [isMobile, isOnlines, is744, is743, is834, isBook])


  //Уберу , когда закончу с книгами @Artem
  const showMobLayout = useMemo(() => {
    if (isOnlines && isMobile) return true;
    if (!isOnlines && is743) return true;
    return false
  }, [isOnlines, isMobile, is744, is834, is743, isBook ])
    const isCollectionVote = project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)

  return (
    <FlexBox direction="column" directionMobile="column">
        {props.project && <BlockedProjectBanner 
          project={props.project} 
          isTemporaryBlocked={blockedState?.isBlocked}
          temporaryBlockingReasons={blockedState?.reasons}
          temporaryOtherReason={blockedState?.otherReason}
        />}
        {showDespLayout && (
        <ProjectContainerLayout
          isProjectPage={!isBookMainPage && !isOnlines}
          isBookMainPage={!!isBookMainPage}
          isCollectionVote={isCollectionVote}
          header={<>
            {showHeaderOnTop && 
              <ProjectHeader 
                project={props.project} 
                fireClick={isPreview} 
                isProjectPage={!isBookMainPage && !isOnlines} 
                isBookPage={!!isBookMainPage} 
              />}
            </>}
          rightSide={
            <FlexBox
              direction="column"
              directionMobile="column"
              justify="space-between"
              width="100%"
              ref={rightSideRef}
              height="100%"
              style={{position: 'relative'}}
            >
              {!isMobile && props.placeElement && <div style={{position: 'absolute', right: is1200 ? '-34px' : '-64px'}}>{props.placeElement}</div>}
              <FlexBox direction="column" directionMobile='column'>
                {props?.bookBuyProcessingComponent ? props?.bookBuyProcessingComponent :  isDeziiign ? (
                  <>
                    <FlexBox offsetBottom={24} gy={isBookChapter ? 0 : 8} direction={'column'} directionMobile='column' justify="space-between" align="flex-start">
                      {isBookChapter && (
                        <FlexBox width={'100%'} offsetBottom={16}>
                          <MainBookTitle book={props.project} />
                        </FlexBox>
                      )}
                      {props.isLoading ? (
                        <Skeleton
                          style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                          width={wx}
                          height={64}
                        />
                      ) : (
                        <FlexBox>
                          {props.title}
                        </FlexBox>
                      )}
                      {/* @ts-ignore */}
                     {!props.isOwner && i18n.language === 'en' && props.project?.autoTranslateStatus === AutoTranslateStatus.Complete && <TranslatedLg offsetTop={16}><span>{t('project_edit.lg_automatically_translated')}</span>
                      <span style={{marginTop: '-2px'}}><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.2241e-08 5.20356C5.2241e-08 5.40902 0.132188 5.59169 0.327656 5.65525L2.39344 6.32659L3.06422 8.39139C3.09525 8.48666 3.15563 8.56967 3.23671 8.62854C3.3178 8.6874 3.41543 8.7191 3.51562 8.7191C3.61582 8.7191 3.71345 8.6874 3.79454 8.62854C3.87562 8.56967 3.936 8.48666 3.96703 8.39139L4.63922 6.32659L6.70359 5.65525C6.79887 5.62418 6.88187 5.56377 6.94072 5.48266C6.99957 5.40156 7.03126 5.30391 7.03125 5.2037C7.03125 4.99811 6.89906 4.81572 6.70359 4.75216L4.63922 4.08081L3.96703 2.01602C3.93607 1.92067 3.87572 1.83758 3.79463 1.77866C3.71354 1.71973 3.61587 1.68799 3.51562 1.68799C3.41538 1.68799 3.31771 1.71973 3.23662 1.77866C3.15553 1.83758 3.09518 1.92067 3.06422 2.01602L2.39344 4.08081L0.327656 4.75216C0.232373 4.78316 0.149351 4.84354 0.0904903 4.92463C0.0316299 5.00572 -4.69545e-05 5.10336 5.2241e-08 5.20356Z" fill="#909090"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.15781 0.194686C7.13961 0.138136 7.10394 0.0888189 7.05592 0.0538339C7.00791 0.018849 6.95003 0 6.89062 0C6.83122 0 6.77334 0.018849 6.72533 0.0538339C6.67731 0.0888189 6.64164 0.138136 6.62344 0.194686L6.21844 1.43795L4.97531 1.84225C4.86 1.87994 4.78125 1.98794 4.78125 2.10972C4.78125 2.2315 4.86 2.3395 4.97531 2.37719L6.21844 2.78148L6.62344 4.02475C6.64164 4.0813 6.67731 4.13061 6.72533 4.1656C6.77334 4.20058 6.83122 4.21943 6.89062 4.21943C6.95003 4.21943 7.00791 4.20058 7.05592 4.1656C7.10394 4.13061 7.13961 4.0813 7.15781 4.02475L7.56281 2.78148L8.80594 2.37719C8.92125 2.3395 9 2.2315 9 2.10972C9 1.98794 8.92125 1.87994 8.80594 1.84225L7.56281 1.43795L7.15781 0.194686Z" fill="#909090"/>
                      </svg></span>
                      </TranslatedLg>} 
                      {props?.firstLine && (
                        <FlexBox>
                            {props.firstLine}
                        </FlexBox>
                      )}
                    </FlexBox>

                    {props.isLoading ? (
                      <Skeleton
                        style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                        width={wx}
                        height={57}
                      />
                    ) : (
                        <>
                          {
                            <FlexBox direction='column' directionMobile='column' style={{ position: 'relative' }}>
                              <FlexBox gx={16} gxMobile={8} width="100%">
                                {/* @ts-ignore */}
                                <BTagsGridNew id="tags_container" gap={10} scroll={collapseTags} shadow isProjectPage>
                                  {props.tags}
                                </BTagsGridNew>
                                {props?.editorTags || null}
                              </FlexBox>
                              {props.protectStatus}
                              {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length) ? (
                                  <RelatedWrapper direction='column'>
                                    <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                                    <FlexBox wrap='wrap' >
                                      {!!cards?.length && !isLoadingTags && (
                                        cards.map((card, index) => {                                         
                                          return <span style={{ marginRight: '8px', marginBottom: '8px' }} {...{
                                              'data-tip': card.name,
                                              'data-for': card.cardId
                                            }}>
                                              <a href={handleOpenProductPage(card)} target='_blank'><BTag>{isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}</BTag></a>
                                              <ReactTooltip {...getTooltipStyles(theme)} {...{id: card.cardId, className: card.cardId}} />
                                            </span>
                                        })
                                      )}
                                      {!!isReproduction?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCardPage}>{t('reproductions')}</BTag></span>
                                      )}
                                      {!!includedCollection?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                      )}
                                      {!!includedCalendar?.length && (
                                        <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                      )}
                                    </FlexBox>
                                  </RelatedWrapper>
                                ) : null
                              }

                            </FlexBox>
                          }
                        </>
                    )}
                  </>
                ) : (
                  <>
                    <FlexBox offsetBottom={(isMac13 && !isBookMainPage) ? 16 : !!isBookMainPage ? 24 : 16} gx={0} direction={'column'} directionMobile='column' justify="space-between" align="flex-start">
                      {isBookChapter && (
                        <FlexBox width={'100%'} offsetBottom={16}>
                          <MainBookTitle book={props.project} />
                        </FlexBox>
                      )}
                      <FlexBox offsetBottom={24} gx={8} justify="space-between" align="flex-start" width={'100%'}>
                        {props.isLoading ? (
                          <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={wx}
                            height={64}
                          />
                        ) : (
                          <FlexBox>
                            {props.title}
                          </FlexBox>
                        )}
                        {props?.firstLine && (
                          <FlexBox>
                            {props.firstLine}
                          </FlexBox>
                        )} 
                      </FlexBox>
                      <FlexBox width={'100%'}>
                        {props.isLoading ? (
                          <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={wx}
                            height={57}
                          />
                        ) : (
                          <FlexBox direction='column'>
                          {/*@ts-ignore*/}
                            <BTagsGridNew id={'tags_container'} gap={10} scrollMode="all" shadow>
                              {props.tags}
                            </BTagsGridNew>
                            {props.protectStatus}
                            {!!props.statusVisible && (
                              <FlexBox offsetTop={52}>
                                {props.status}
                              </FlexBox>
                            )}
                          </FlexBox>
                        )}
                      </FlexBox>
                      {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length) ? (
                          <RelatedWrapper direction='column'>
                            <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                              <FlexBox wrap='wrap' >
                                {!!cards?.length && (
                                  cards.map((card, index) => {
                                          
                                    return <span style={{ marginRight: '8px', marginBottom: '8px' }} {...{
                                      'data-tip': card.name,
                                      'data-for': card.cardId
                                      }}>
                                  {/*@ts-ignore*/}
                                  <a href={handleOpenProductPage(card)} target='_blank'><BTag>{isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}</BTag></a>
                                  <ReactTooltip {...getTooltipStyles(theme)} {...{id: card.cardId, className: card.cardId}} />
                                  </span>
                                  })
                                )}
                                {!!isReproduction?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCardPage}>{t('reproductions')}</BTag></span>
                                )}
                                {!!includedCollection?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                )}
                                {!!includedCalendar?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                )}
                              </FlexBox>
                            </RelatedWrapper>
                          ) : null
                        }
                    </FlexBox>
                  </>
                )}
              </FlexBox>
              <FlexBox>
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                    width={wx}
                    height={32}
                  />
                ) : (
                  <FlexBox direction={isMaskSwitcherVisibile ? 'row' : 'column'} directionMobile={isMaskSwitcherVisibile ? 'row' : 'column'} width={'100%'}>
                    {props.bottom}
                    {isMaskSwitcherVisibile && <MaskSwitcher project={props?.project} />}
                  </FlexBox>
                )}
                {props.queueButtons}
              </FlexBox>
            </FlexBox>
          }
          leftSide={
            <ProjectImageWrapper isProjectPage={!isBookMainPage && !isOnlines} isBooks={!!isBookMainPage}>
              {isMobile && props.placeElement && <div style={{position: 'absolute', left: '10px', top: '-3px'}}>{props.placeElement}</div>}
              {props.isLoading ? (
                <Skeleton
                  style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                  width="100%"
                  height="100%"
                />
              ) : (
                props.image
              )}
            </ProjectImageWrapper>
          }
        />
      )}

      {showMobLayout && (
        <ProjectContainerLayout
          isBookMainPage={!!isBookMainPage}
          rightSide={

            <FlexBox direction="column" directionMobile="column" width="100%" ref={rightSideRef}>
              {isBookMainPage && isMobile && !is743 && (
                <div className="ProjectHeaderOuterMobile">
                  <div className="ProjectHeaderTitleMobile">
                    {props.title}
                  </div>
                </div>
              )}
              {!!isBookMainPage && isMobile && !is743 ? (
                <FlexBox offsetTopMobile={24}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={57}
                    />
                  ) : (
                    <FlexBox direction='column'>
                      <BTagsGridNew id="tags_container" scrollMode="all" shadow>
                        {props.tags}
                      </BTagsGridNew>
                      <FlexBox offsetTop={52}>
                        {props.status}
                      </FlexBox>
                    </FlexBox>
                  )}
                </FlexBox>
              ) : (
                <FlexBox offsetTop={isMobile ? 24 : 24}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={32}
                    />
                  ) : (
                    <BottomOuterMobile>
                      <div className="BottomOuterMobileLikes">
                        {props.likesSticker}
                      </div>

                      <div className="BottomOuterMobileActions">
                        <FlexBox directionMobile="row" gxMobile={12}>
                          {isTagsButtonVisible && <TagsMobBtn onClick={handleToggleMobileTagClick} flag={showMobileTags} />}
                        </FlexBox>
                      </div>
                    </BottomOuterMobile>
                  )}
                </FlexBox>
              )}
              {isBookMainPage && isMobile && (
                <FlexBox offsetTopMobile={isBookMainPage && isMobile && !is743 ? 'auto' : 0}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={32}
                    />
                  ) : (
                    <FlexBox direction='column' directionMobile='column' width={'100%'}>
                      {props.bottom}
                    </FlexBox>
                  )}
                </FlexBox>
              )}

              {(props.firstLine || props.isLoading) && (
                <FlexBox offsetTop={25}>
                  {props.isLoading ? (
                    <Skeleton
                      style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                      width={wx}
                      height={40}
                    />
                  ) : (
                    props.firstLine
                  )}
                </FlexBox>
              )}

              <FlexBox offsetTop={(props.isLoading || showMobileTags) ? 24 : 0}>
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor, marginBottom: '14px' }}
                    width={wx}
                    height={57}
                  />
                ) : (
                  <>
                    <MobBottomWrapper 
                      directionMobile="column"
                      widthMobile={'100%'} 
                      shouldMobOffset={
                        isGeograffee && 
                        props.point && 
                        !showMobileTags
                      }
                    >
                      {props.purchase}
                      {showMobileTags && (
                        <>
                          <FlexBox gx={16} gxMobile={8} width="100%">
                            <TagsMobile show={showMobileTags} scroll={collapseTags} background={tagsGradientColor}>
                              {props.tags}
                            </TagsMobile>
                            {props?.editorTags || null}
                          </FlexBox>

                      </>
                      )}
                      {(isReproduction?.length || cards?.length || includedCollection?.length || includedCalendar?.length)? (
                            <RelatedWrapper direction="column">
                              <RelatedTitle>{t('relatedProject')}</RelatedTitle>
                              <FlexBox wrap="wrap">
                                {!!cards?.length && cards.map((card, index) => (
                                  <span
                                    key={card.cardId}
                                    style={{ marginRight: 8, marginBottom: 8 }}
                                    data-tip={card.name}
                                    data-for={card.cardId}
                                  >
                                    <a href={handleOpenProductPage(card)} target='_blank'><BTag>
                                      {isBookProject? 'Электронная книга' : API.toLang<Tag>(tags?.[index], i18n.language)?.name || formatSequenceNumber(card.sequenceItem?.number)}
                                    </BTag></a>
                                    <ReactTooltip
                                      {...getTooltipStyles(theme)}
                                      id={card.cardId}
                                      className={card.cardId}
                                    />
                                  </span>
                                ))}
                                {!!isReproduction?.length && (
                                  <span style={{ marginRight: 8, marginBottom: 8 }}>
                                    <BTag onClick={handleOpenCardPage}>
                                      {t('reproductions')}
                                    </BTag>
                                  </span>
                                )}
                                {!!includedCollection?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCollectionPage}>{t('included_collection')}</BTag></span>
                                )}
                                {!!includedCalendar?.length && (
                                  <span style={{ marginRight: '8px', marginBottom: '8px' }}><BTag onClick={handleOpenCalendarPage}>{t('included_calendar')}</BTag></span>
                                )}
                              </FlexBox>
                            </RelatedWrapper>
                          ) : undefined}
                      {isMaskSwitcherVisibile && <MaskSwitcher project={props?.project} minOffset={showMobileTags} />}
                    </MobBottomWrapper>
                  </>
                )}
              </FlexBox>
              {/* @ts-ignore */}
              {!props.isOwner && i18n.language === 'en' && props.project?.autoTranslateStatus === AutoTranslateStatus.Complete && <TranslatedLg offsetTop={16}><span>{t('project_edit.lg_automatically_translated')}</span>
                      <span style={{marginTop: '-2px'}}><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.2241e-08 5.20356C5.2241e-08 5.40902 0.132188 5.59169 0.327656 5.65525L2.39344 6.32659L3.06422 8.39139C3.09525 8.48666 3.15563 8.56967 3.23671 8.62854C3.3178 8.6874 3.41543 8.7191 3.51562 8.7191C3.61582 8.7191 3.71345 8.6874 3.79454 8.62854C3.87562 8.56967 3.936 8.48666 3.96703 8.39139L4.63922 6.32659L6.70359 5.65525C6.79887 5.62418 6.88187 5.56377 6.94072 5.48266C6.99957 5.40156 7.03126 5.30391 7.03125 5.2037C7.03125 4.99811 6.89906 4.81572 6.70359 4.75216L4.63922 4.08081L3.96703 2.01602C3.93607 1.92067 3.87572 1.83758 3.79463 1.77866C3.71354 1.71973 3.61587 1.68799 3.51562 1.68799C3.41538 1.68799 3.31771 1.71973 3.23662 1.77866C3.15553 1.83758 3.09518 1.92067 3.06422 2.01602L2.39344 4.08081L0.327656 4.75216C0.232373 4.78316 0.149351 4.84354 0.0904903 4.92463C0.0316299 5.00572 -4.69545e-05 5.10336 5.2241e-08 5.20356Z" fill="#909090"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.15781 0.194686C7.13961 0.138136 7.10394 0.0888189 7.05592 0.0538339C7.00791 0.018849 6.95003 0 6.89062 0C6.83122 0 6.77334 0.018849 6.72533 0.0538339C6.67731 0.0888189 6.64164 0.138136 6.62344 0.194686L6.21844 1.43795L4.97531 1.84225C4.86 1.87994 4.78125 1.98794 4.78125 2.10972C4.78125 2.2315 4.86 2.3395 4.97531 2.37719L6.21844 2.78148L6.62344 4.02475C6.64164 4.0813 6.67731 4.13061 6.72533 4.1656C6.77334 4.20058 6.83122 4.21943 6.89062 4.21943C6.95003 4.21943 7.00791 4.20058 7.05592 4.1656C7.10394 4.13061 7.13961 4.0813 7.15781 4.02475L7.56281 2.78148L8.80594 2.37719C8.92125 2.3395 9 2.2315 9 2.10972C9 1.98794 8.92125 1.87994 8.80594 1.84225L7.56281 1.43795L7.15781 0.194686Z" fill="#909090"/>
                      </svg></span>
                      </TranslatedLg>} 
            </FlexBox>
          }
          leftSide={
            <ProjectLeftSectionOuterMobile isAgeytomesh={isAgeytomesh}>
                <MobileBookTitleOuter hide={!!isBookMainPage}>
                  {props?.contextName && props?.contextName}
                  <div className="ProjectHeaderOuterMobile">
                    {isBookChapter ? (
                      <FlexBox width={'100%'} offsetBottomMobile={16}>
                        <MainBookTitle book={props.project} />
                      </FlexBox>
                    ) : (
                      !isSuperPuper && <ProjectHeader project={props.project} fireClick={isPreview} />
                    )}
                    <div className="ProjectHeaderTitleMobile">
                      {props.title}
                    </div>
                  </div>
                </MobileBookTitleOuter>

              <ProjectImageWrapper isProjectPage={!!isBookMainPage}>
                {props.bookmarkButtonMobile}
                {props.placeElement && <div style={{position: 'absolute', right: '10px', top: '-3px'}}>{props.placeElement}</div>}
                {props.isLoading ? (
                  <Skeleton
                    style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                    width="100%"
                    height="100%"
                  />
                ) : (
                  props.image
                )}
              </ProjectImageWrapper>
            </ProjectLeftSectionOuterMobile>
          }
        />
      )}

      {props.gameInfo}
      {showMobLayout && !isBookMainPage && <>
        <FlexBox width="100%" direction="column" directionMobile="column" align="center">
          {props.bookBuyProcessingComponent && <FlexBox width="calc(100% - 20px)" offsetBottom={16}>
            {props.bookBuyProcessingComponent}
          </FlexBox>}
          {props.bottom}
        </FlexBox>
      </>}
      {props.inPartExam}
      {props.studentProject}
      {props.inPartCompetition}
      {!props.project?.isBook && (
        <VoteLongreadBlockWrapper justify='center' align='center'>

            <VoteBlock project={props.project} fullSize position={VOTE_BLOCK_POSITION.longread} />

        </VoteLongreadBlockWrapper>
      )}

      {props?.queue && <QueueWrapper width="100%" offsetTop={24} justify="center">
        {props?.queue}
      </QueueWrapper>}

      {props.subscribeInfo && (
        <FlexBox>
          {props.subscribeInfo}
        </FlexBox>
      )}

      {props.roomLaunchBlock && (
        <FlexBox offsetTop={40} offsetTopMobile={20} offsetBottomMobile={20}>
          {props.roomLaunchBlock}
        </FlexBox>
      )}

      <ProjectLongreadWrapper showTags={showMobileTags} vtype={viewType} isBooks={!!isBookMainPage || !!isBookProjectPage}>
        {props.isLoading ? <Skeleton style={{ marginLeft: 'auto', marginRight: 'auto' }} offsetTop={24} offsetTopMobile={8} width="100%" widthMobile={is743 ? 'calc(100% - 20px)' : '100%'} height={100}/> : props.longread}
        {props.LMSLongreads}
      </ProjectLongreadWrapper>

      <VoteLongreadBlockWrapper justify='center' align='center'>

          <VoteBlock project={props.project} fullSize position={VOTE_BLOCK_POSITION.bottom} />

      </VoteLongreadBlockWrapper>
    </FlexBox>
  );
};

export default memo(ProjectDisplayLayout);
